
const Cjenik = function(DS) {

    return DS.defineResource({
        name: 'Cjenik',
        endpoint: '/cjenici',
        // methods: {
        //     getNazivValute: function() {
        //         let id = this.valuta;
        //         return DS.find('Valuta', id).then((item) => {
        //             return item.valuta;
        //         });

        //         // return DS.get('Valuta', id).valuta;
        //     }
        // },
        // relations: {
        //     belongsTo: {
        //         Valuta: {
        //             localField: 'valuta',
        //             localKey: 'valuta_id'
        //         }
        //     }
        // }

    });
};

Cjenik.$inject = ['DS'];


export {Cjenik};



// WEBPACK FOOTER //
// ./app/models/cjenik.js